<script setup>
import { useSertStore } from '@/stores/sertStore';

const storeSert = useSertStore();

defineProps({
    text: {
        type: Object,
    },
    index: {
        type: Number
    }
})

const emit = defineEmits(['activeMessage'])

const selectMessage = (message, index) => {
    storeSert.updateCheckedItem('message', 'title', message);
 
    const isValid = message?.trim().length >= 5;

    storeSert.updateCheckedItem('message', 'disabledBtn', isValid);
    emit('activeMessage', index)
}
</script>
<template>
    <label class="radio ">
        <input
            type="radio"
            :checked="storeSert.checkedItems.message.title === text.message"
            @change="selectMessage(text.message, index)"
            :value="text.message"
            class="radio__real-radio"
        >
        <span class="radio__custom-radio">{{ text.message }}</span>
    </label>                   
</template>
<style lang='scss' scoped>
</style>